import { render, staticRenderFns } from "./resultCard.vue?vue&type=template&id=55bd94e6&scoped=true"
import script from "./resultCard.vue?vue&type=script&lang=js"
export * from "./resultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd94e6",
  null
  
)

export default component.exports